var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.worksArray),function(work,index){return _c('b-container',{key:work.id,staticClass:"a",attrs:{"id":"worksContainerDesktop","p":"0","fluid":""}},[_c(_vm.checkIndex(index),{tag:"component",attrs:{"work":work}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }